import { createContext } from 'react'

export const StateContext = createContext(null)
export const DispatchContext = createContext(null)
